import React, { Component } from 'react';
import { connect } from 'react-redux';
import CinemapSlider from '../../../../SHARED/components/slider/slider.component';
import { requestSliderNews } from '../../../../SHARED/actions/news.actions';
import {slugify} from '../../../../SHARED/helpers/general.helper';

class SliderFestivalContainer extends Component {

    getSlides() {
        if(this.props.slides){
            const items = [];

            this.props.slides.map((item, i) => {
                items.push({
                    key: i,
                    article_title: item.event_title,
                    article_summary: item.event_description,
                    item_link: `/eveniment/${item.event_id}/${slugify(item.event_title)}`,
                    article_image: item.event_image
                });
            });

            return <CinemapSlider slides={items}/>
        }
    }

    render() {
        return (
            <div className="slider-festival-container">
                {this.getSlides()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {requestSliderNews})(SliderFestivalContainer);



// WEBPACK FOOTER //
// ./src/FO/components/festivaldetails/containers/sliderfestivalcontainer.component.js